module.exports = __webpack_public_path__ + "static/media/vector-check-white.13ad7d5a.svg";